import React, {useEffect, useState} from 'react'
import star from "../images/icons/star.png"
import fb from "../images/icons/facebook.png"
const reviewInfo = [

    {
        name: "Gerry H.",
        review: "Hired Ideal to clean out mom's old 2 bedroom apartment when she had to move to assisted living. They responded right away. Did a walk thru and gave a very reasonable estimate. They had everything cleaned out and hauled away in 3 hours. I highly recomend Ideal, they did a great job!",
        date: "January 5, 2023"
    },
    {
        name: "Kelly G.",
        review: "Excellent customer service! Will use them again!",
        date: "May 16, 2022"
    },
    {
        name: "Richard M.",
        review: "I would highly recommend Ideal Disposal to anyone that needs dumpster rentals. I have used there service twice already and both times have been excellent. Matt and his son are promptly on time and always a pleasure to do business with. Ideal disposal is a great company and ran very professionally! I highly recommended!!!",
        date: " April 3, 2022"
    },
    {
        name: "Justine M.",
        review: "Great company and I love that when you call you get Carol. She’s so helpful and kind. We have rented from them many times! I tell all my neighbors and friends to use them as well!",
        date: "January 18, 2021"
    },{
        name: "Angela M.",
        review: "I can tell you I’ll be going to Ideal Disposal for all my needs! I can’t thank them enough. It’s right before a snowstorm and we called them about plowing but we have a pea stone driveway. Of course plowing just isn’t an option for us but that didn’t stop them from helping. Within 20 minutes, Matt was here and helped my husband put together our snowblower!! His generosity will not be forgotten and this just shows how great of a company this is. Needless to say, I highly recommend them because clearly they’ll find a way to get it done for you too.",
        date: "December 16, 2020"
    },
    {
        name: "Krista O.",
        review: "I would recommend Ideal Disposal for your clean out or dumpster rental needs.  They were amazing to work with and very reasonable in price.  They truly made a difficult situation much easier than I could ever imagine.  I can’t thank them enough!",
        date: "August 26, 2019"
    },
    {
        name: "Timothy Z.",
        review: "Great service and very friendly would recommend them to all of my friends",
        date: "June 18, 2019 "
    },
    {
        name: "Mary W.",
        review: "We used Ideal Disposal this winter for snow I found them on the Whitman Pride FB page and they were awesome, then we called them yesterday to come pick up some stuff we needed to get rid of ( old gas grill , folding tables , pieces of old fence ) Matt came over within 15 minutes and took everything away and only charged us $30 they are amazing to do business with I highly recommend them.",
        date:  "April 17, 2019"
    },{
        name: "Scott C.",
        review: "Ideal Disposal was so good to us! We’ve gotten two dumpsters from them in the process of renovating our house. They dropped off and picked up so quickly. The best in the business!",
        date: "December 4, 2018"
    },
    {
        name: "Brittany C.",
        review: "I cannot say enough good things! We just recently used Ideal Disposal for a vinyl siding rehab on our home and we couldn’t be more pleased with their customer service! Dumpster delivered day of and picked up an hour after we confirmed the job was finished! Well done! We will absolutely be using them again in the future",
        date: "December 4, 2018"
    },
    {
        name: "Dave G.",
        review: "Can't say enough great things about Ideal Disposal. I unexpectedly was faced with a situation where I had to empty out an entire 2 floor condo. I ended up hiring Ideal not only for the dumpsters, but also to help clear out the condo and rip up the carpets. What would have taken me months to do on my own, they were able to accomplish in a few short days. They were professional, reliable, fast, flexible and did a great job ",
        date: "July 3, 2018"
    }
]

function Footer() {
//state for review index
    const [reviewIndex, setReviewIndex] = useState(0);

    //handle back button
    const handlePrevReview = () => {
        reviewIndex === 0? setReviewIndex(reviews.length-1): (setReviewIndex( () => reviewIndex - 1))
    }

    //handle forward button
    const handleNextReview = () => {
        reviewIndex === reviews.length-1? setReviewIndex(0): (setReviewIndex( () => reviewIndex + 1))
    }
    useEffect( () => {

        const next = setTimeout(() => {
            handleNextReview();
        }, 8000);
        return () => {
            clearTimeout(next);
        }
    }, [reviewIndex]);


const reviews = reviewInfo.map((el) => {
    return (
        <div className="review">
                <div className= "quote-container">
                    <p className= "review-quote">
                    “
                    {el.review}
                    ”
                    </p>
                    
                    <div className= "quote-tri">
                    </div>
                </div>
                <div className= "reviewer">
                    <p>{el.name}</p>
                    <p>{el.date}</p>
                </div>
                <div className= "stars">
                <img src={star} alt="" />
                <img src={star} alt="" />
                <img src={star} alt="" />
                <img src={star} alt="" />
                <img src={star} alt="" />
                </div>
        </div>
    )

});
// console.log(reviews)



  return (
    <footer>
        <div className="footer-container">

        <div id= "footer-contact">
            <div id= "contact-container">
                <h5>Contact Us</h5>
                <ul>

                    <li>781-228-8783</li>
                    <li>IdealDisposalServices@gmail.com</li>
                    <li>
                        <a id= "contact-social" href= "https://www.facebook.com/IDEALDISPOSAL" target='_blank'>
                           <img src={fb} alt="Facebook logo" />
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <section id= "review-carousel">
        <button id="left-arrow" className= "review-arrow" onClick= {handlePrevReview}>&lt;</button>
            
            {reviews[reviewIndex]}
            {/* <div className="review">
                <div className= "quote-container">
                    <p className= "review-quote">
                    “
                    I would highly recommend Ideal Disposal to anyone that needs dumpster rentals. I have used there service twice already and both times have been excellent. Matt and his son are promptly on time and always a pleasure to do business with. Ideal disposal is a great company and ran very professionally! I highly recommended!!!
                    ”
                    </p>
                    
                    <div className= "quote-tri">
                    </div>
                </div>
                <div className= "reviewer">
                    <p>Richard Mack</p>
                    <p>Jan 5, 2023</p>
                </div>
                <div className= "stars">
                <img src={star} alt="" />
                <img src={star} alt="" />
                <img src={star} alt="" />
                <img src={star} alt="" />
                <img src={star} alt="" />
                </div>
            </div> */}
            <button id="right-arrow" className= "review-arrow" onClick= {handleNextReview}>&gt;</button>
            
            
        </section>
        </div>
    </footer>
  )
}

export default Footer;